import { render, staticRenderFns } from "./CategoriaCreate.vue?vue&type=template&id=2e0489a8"
import script from "./CategoriaCreate.vue?vue&type=script&lang=js"
export * from "./CategoriaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports